const postsToRefresh = new Set();
const refreshingPosts = new Set();

function postNumberFromUrl(url) {
  const pathname = new URL(url, globalThis.location.origin).pathname;
  const match = new RegExp(/^\/posts\/([^/]+)$/).exec(pathname);

  return match ? decodeURIComponent(match[1]) : null;
}

document.addEventListener("turbo:before-visit", event => {
  const postNumber = postNumberFromUrl(event.detail.url);
  if (postNumber) postsToRefresh.add(postNumber);
});

document.addEventListener("turbo:before-render", event => {
  const newBody = event.detail.newBody;
  // The expanded page also contains a feed card. Keep it marked until we
  // return to a list, rather than consuming the refresh while opening it.
  if (newBody.querySelector(".show-post, .show-post-modal")) return;
  if (!newBody.querySelector("[data-cache-refresh-post-number]")) return;
  if (postsToRefresh.size === 0) return;

  event.preventDefault();
  const refreshBeforeRender = async () => {
    const { flushPollSubmissions } = await import("../controllers/user_controller");
    await flushPollSubmissions();
    await Promise.all(Array.from(postsToRefresh, postNumber => refreshPost(postNumber, newBody)));
  };
  refreshBeforeRender()
    .catch(error => console.error("Unable to prepare refreshed posts:", error))
    .finally(() => event.detail.resume());
});

async function refreshPost(postNumber, newBody) {
  if (refreshingPosts.has(postNumber)) return;
  refreshingPosts.add(postNumber);

  try {
    const response = await fetch(
      `/posts/${encodeURIComponent(postNumber)}/refresh_feed_card`,
      {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-Requested-With": "XMLHttpRequest"
        },
        cache: "no-store",
        credentials: "same-origin"
      }
    );

    if (!response.ok) return;

    const stream = await response.text();
    if (!stream.trim()) return;

    const parsed = new DOMParser().parseFromString(stream, "text/html");
    let replaced = false;
    for (const update of parsed.querySelectorAll("turbo-stream[action='replace'][targets]")) {
      const template = update.querySelector("template");
      if (!template) continue;
      for (const target of newBody.querySelectorAll(update.getAttribute("targets"))) {
        target.replaceWith(template.content.cloneNode(true));
        replaced = true;
      }
    }
    if (replaced) postsToRefresh.delete(postNumber);
  } catch (error) {
    console.error("Unable to refresh cached post:", error);
  } finally {
    refreshingPosts.delete(postNumber);
  }
}
